/* Latest podcast episode: reads the show's RSS feed in the browser and plays the newest episode inline. */
(function () {
  'use strict';
  function track(name, detail) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, detail || {}); } catch (e) {}
    try { if (window.gtag) window.gtag('event', name, detail || {}); } catch (e) {}
  }
  /* ---------- Podcast: latest episode from RSS, played in a custom player ---------- */
  function initEpisode(pod) {
    var rss = pod.getAttribute('data-rss'); if (!rss) return;
    var P = function (sel) { return pod.querySelector(sel); };
    var audio = P('[data-pod-audio]'), bar = P('[data-pod-bar]'), fill = P('[data-pod-fill]'), knob = P('[data-pod-knob]');
    var fmt = function (t) { if (!isFinite(t)) return '0:00'; t = Math.max(0, Math.floor(t)); var h = Math.floor(t / 3600), m = Math.floor(t % 3600 / 60), sec = t % 60; return (h ? h + ':' + String(m).padStart(2, '0') : m) + ':' + String(sec).padStart(2, '0'); };
    var durText = function (d) { if (!d) return ''; if (/^\d+$/.test(d)) { var m = Math.round(+d / 60); return m + '\u00a0min'; } var p2 = d.split(':').map(Number); var secs = p2.reduce(function (a, b) { return a * 60 + b; }, 0); return Math.round(secs / 60) + '\u00a0min'; };
    fetch(rss).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (xml) {
      var doc = new DOMParser().parseFromString(xml, 'text/xml');
      var item = doc.querySelector('item'); if (!item) throw new Error('no items');
      var q = function (tag) { var el = item.getElementsByTagName(tag)[0]; return el ? el.textContent.trim() : ''; };
      var enc = item.querySelector('enclosure');
      var title = q('title'), date = q('pubDate'), dur = q('itunes:duration'), ep = q('itunes:episode');
      // Titles like "Episode 101 // Another Version: ..." split into a number and a clean title.
      var m2 = title.match(/^\s*(?:Episode|Ep\.?)\s*(\d+)\s*(?:\/\/|[-–—:|])\s*(.+)$/i);
      if (m2) { ep = ep || String(+m2[1]); title = m2[2]; }
      P('[data-pod-title]').textContent = title;
      var meta = [];
      if (ep) meta.push('Ep. ' + ep);
      if (date) { try { meta.push(new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })); } catch (e) {} }
      if (dur) meta.push(durText(dur));
      P('[data-pod-meta]').textContent = meta.join(' · ');
      if (dur) { var ds = /^\d+$/.test(dur) ? +dur : dur.split(':').map(Number).reduce(function (a, b) { return a * 60 + b; }, 0); P('[data-pod-left]').textContent = '–' + fmt(ds); }
      if (date && Date.now() - new Date(date).getTime() < 14 * 864e5) { P('[data-pod-flag]').textContent = 'New episode'; pod.classList.add('is-new'); }
      var descEl = P('[data-pod-desc]');
      if (descEl) {
        var raw = q('description') || q('itunes:summary');
        var tmp = new DOMParser().parseFromString(raw, 'text/html');
        var txt = (tmp.body.textContent || '').replace(/\s+/g, ' ').trim();
        if (txt) { descEl.textContent = txt.length > 240 ? txt.slice(0, 240).replace(/\s+\S*$/, '') + '…' : txt; descEl.hidden = false; }
      }
      if (enc && enc.getAttribute('url')) {
        audio.src = enc.getAttribute('url');
        P('[data-pod-player]').hidden = false;
      }
    }).catch(function (e) { if (window.console) console.warn('[links] podcast feed unavailable', e); });

    var setPos = function () {
      var pct = audio.duration ? audio.currentTime / audio.duration * 100 : 0;
      fill.style.width = pct + '%'; knob.style.left = pct + '%'; bar.setAttribute('aria-valuenow', Math.round(pct));
      P('[data-pod-now]').textContent = fmt(audio.currentTime);
      P('[data-pod-left]').textContent = '–' + fmt((audio.duration || 0) - audio.currentTime);
    };
    audio.addEventListener('timeupdate', setPos);
    audio.addEventListener('loadedmetadata', setPos);
    audio.addEventListener('play', function () { pod.classList.add('is-playing', 'is-started'); P('[data-pod-play]').setAttribute('aria-label', 'Pause episode'); });
    audio.addEventListener('pause', function () { pod.classList.remove('is-playing'); P('[data-pod-play]').setAttribute('aria-label', 'Play episode'); });
    var started = false;
    P('[data-pod-play]').addEventListener('click', function () {
      if (audio.paused) { audio.play(); if (!started) { started = true; track('podcast_play', { title: P('[data-pod-title]').textContent }); } }
      else audio.pause();
    });
    var seekAt = function (x) { var r = bar.getBoundingClientRect(); var f = Math.min(1, Math.max(0, (x - r.left) / r.width)); if (audio.duration) { audio.currentTime = f * audio.duration; setPos(); } };
    var seeking = false;
    bar.addEventListener('pointerdown', function (e) { seeking = true; bar.setPointerCapture(e.pointerId); seekAt(e.clientX); });
    bar.addEventListener('pointermove', function (e) { if (seeking) seekAt(e.clientX); });
    bar.addEventListener('pointerup', function () { seeking = false; });
    bar.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { audio.currentTime = Math.min(audio.duration || 0, audio.currentTime + 15); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { audio.currentTime = Math.max(0, audio.currentTime - 15); e.preventDefault(); }
    });
  }


  function boot() { document.querySelectorAll('[data-pod][data-rss]').forEach(initEpisode); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
